import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import EditorLayout from '../components/layout';
import useEditorItemContext from '../../context/editorItemContext';
import generateBlankData from '../../generator/generateBlankData';

const BlankSource = props => {
  const { template } = useEditorItemContext();

  useEffect(() => {
    props.onSuccess(() => generateBlankData(template));
  }, []);

  return <EditorLayout primaryChildren={props.children} />;
};

BlankSource.propTypes = {
  onSuccess: PropTypes.func,
  children: PropTypes.node,
};

export default BlankSource;
